import React, {useCallback, useEffect, useState} from 'react';
import {createPortal} from 'react-dom';
import {openObjectInNewTab} from '../utils/objectLinks';

const MENU_CLASS = 'object-context-menu-root';

/**
 * Глобальное контекстное меню по postMessage showObjectContextMenu (десктоп).
 * Пункт: открыть объект справочника в новой вкладке.
 */
export default function ObjectContextMenu() {
    const [menu, setMenu] = useState(null);

    useEffect(() => {
        const onMsg = (event) => {
            if (!event.data || event.data.type !== 'showObjectContextMenu') {
                return;
            }
            const {x, y, objectType, objectId} = event.data;
            if (objectType == null || objectId == null) {
                return;
            }
            setMenu({x, y, objectType, objectId});
        };
        window.addEventListener('message', onMsg);
        return () => window.removeEventListener('message', onMsg);
    }, []);

    const close = useCallback(() => setMenu(null), []);

    useEffect(() => {
        if (!menu) {
            return undefined;
        }
        const onMouseDown = (e) => {
            if (e.target.closest && e.target.closest(`.${MENU_CLASS}`)) {
                return;
            }
            close();
        };
        const onKey = (e) => {
            if (e.key === 'Escape') {
                close();
            }
        };
        const onScroll = () => close();

        document.addEventListener('mousedown', onMouseDown, true);
        document.addEventListener('keydown', onKey, true);
        window.addEventListener('scroll', onScroll, true);
        return () => {
            document.removeEventListener('mousedown', onMouseDown, true);
            document.removeEventListener('keydown', onKey, true);
            window.removeEventListener('scroll', onScroll, true);
        };
    }, [menu, close]);

    if (!menu) {
        return null;
    }

    const pad = 8;
    let left = menu.x;
    let top = menu.y;
    const estW = 220;
    const estH = 44;
    if (typeof window !== 'undefined') {
        if (left + estW + pad > window.innerWidth) {
            left = Math.max(pad, window.innerWidth - estW - pad);
        }
        if (top + estH + pad > window.innerHeight) {
            top = Math.max(pad, window.innerHeight - estH - pad);
        }
    }

    const node = (
        <div
            className={MENU_CLASS}
            style={{
                position: 'fixed',
                left,
                top,
                zIndex: 10050,
                minWidth: 200,
                background: 'var(--vkui--color_background_modal)',
                boxShadow: 'var(--vkui--elevation3)',
                borderRadius: 8,
                border: '1px solid var(--vkui--color_separator_primary)',
                overflow: 'hidden',
            }}
            role="menu"
        >
            <button
                type="button"
                style={{
                    display: 'block',
                    width: '100%',
                    textAlign: 'left',
                    padding: '10px 14px',
                    border: 'none',
                    background: 'transparent',
                    cursor: 'pointer',
                    fontSize: '14px',
                    color: 'var(--vkui--color_text_primary)',
                }}
                onClick={() => {
                    openObjectInNewTab(menu.objectType, menu.objectId);
                    close();
                }}
            >
                Открыть в новой вкладке
            </button>
        </div>
    );

    return createPortal(node, document.body);
}
